/* Custom styled dropdown for the collection/search sort select.
   The native <select> stays in the DOM (hidden) and keeps driving
   facets.js via dispatched change events. */
(function () {
  function enhance(select) {
    if (select.dataset.sceEnhanced) return;
    select.dataset.sceEnhanced = 'true';

    const wrap = document.createElement('div');
    wrap.className = 'sce-select';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sce-select__button';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<span>' + (select.options[select.selectedIndex]?.text || '') + '</span>' +
      '<svg viewBox="0 0 10 6" aria-hidden="true" class="sce-select__caret"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

    const list = document.createElement('ul');
    list.className = 'sce-select__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    Array.prototype.forEach.call(select.options, function (o, i) {
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.className = 'sce-select__option';
      li.textContent = o.text;
      li.setAttribute('aria-selected', i === select.selectedIndex ? 'true' : 'false');
      li.addEventListener('click', function () { choose(i); });
      list.appendChild(li);
    });

    function open() {
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      (list.querySelector('[aria-selected="true"]') || list.firstElementChild)?.focus();
    }
    function close(focusBtn) {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (focusBtn) btn.focus();
    }
    function choose(i) {
      select.selectedIndex = i;
      Array.prototype.forEach.call(list.children, function (li, j) {
        li.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
      btn.firstElementChild.textContent = select.options[i].text;
      close(true);
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    btn.addEventListener('click', function () { list.hidden ? open() : close(false); });
    list.addEventListener('keydown', function (e) {
      const items = Array.prototype.slice.call(list.children);
      const idx = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(idx + 1, items.length - 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); items[Math.max(idx - 1, 0)].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(idx); }
      else if (e.key === 'Escape') { close(true); }
      else if (e.key === 'Tab') { close(false); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(false); });

    select.parentElement.insertBefore(wrap, select);
    wrap.appendChild(btn);
    wrap.appendChild(list);
    select.closest('.select')?.classList.add('sce-select--native-hidden');
  }

  function init() {
    document.querySelectorAll('.facet-filters__sort, .mobile-facets__sort .select__select').forEach(enhance);
  }
  init();
  document.addEventListener('shopify:section:load', init);
  // facets.js re-renders the toolbar after every filter/sort change
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();
